var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2524_19371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4501 25.4167L20.8334 22.0833V14.5333C20.8334 13.8667 20.3001 13.3333 19.6334 13.3333H19.5334C18.8667 13.3333 18.3334 13.8667 18.3334 14.5333V22.4C18.3334 22.9833 18.6334 23.5333 19.1501 23.8333L25.2334 27.4833C25.8001 27.8167 26.5334 27.65 26.8667 27.0833C27.2167 26.5 27.0334 25.75 26.4501 25.4167V25.4167ZM35.3001 8.34999L30.1667 4.08333C29.4667 3.5 28.4167 3.58333 27.8167 4.29999C27.2334 4.99999 27.3334 6.04999 28.0334 6.64999L33.1501 10.9167C33.8501 11.5 34.9001 11.4167 35.5001 10.7C36.1001 9.99999 36.0001 8.94999 35.3001 8.34999V8.34999ZM6.83338 10.9167L11.9501 6.64999C12.6667 6.04999 12.7667 4.99999 12.1667 4.29999C11.5834 3.58333 10.5334 3.5 9.83338 4.08333L4.70005 8.34999C4.00005 8.94999 3.90005 9.99999 4.50005 10.7C5.08338 11.4167 6.13338 11.5 6.83338 10.9167ZM20.0001 6.66666C11.7167 6.66666 5.00005 13.3833 5.00005 21.6667C5.00005 29.95 11.7167 36.6667 20.0001 36.6667C28.2834 36.6667 35.0001 29.95 35.0001 21.6667C35.0001 13.3833 28.2834 6.66666 20.0001 6.66666ZM20.0001 33.3333C13.5667 33.3333 8.33338 28.1 8.33338 21.6667C8.33338 15.2333 13.5667 9.99999 20.0001 9.99999C26.4334 9.99999 31.6667 15.2333 31.6667 21.6667C31.6667 28.1 26.4334 33.3333 20.0001 33.3333Z",
    fill: "#4F4F4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2524_19371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailTime);
export default __webpack_public_path__ + "static/media/detail-time.698ef1a46fc9ea0d969eb37db671bbe8.svg";
export { ForwardRef as ReactComponent };